import React from 'react';
import { useLanguage } from '../../../../../context/LanguageContext';
import '../style/page-header.css';

const PageHeader: React.FC = () => {
    const { t } = useLanguage();
    
    const translation = t as any;
    const store = translation.STORE;
    const navigation = translation.NAVIGATION;

    return (
        <section className="page-header">
            <div 
                className="page-header__bg" 
                style={{
                    backgroundImage: 'url(/assets/logo/store/loja_2.webp)',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    height: '380px'
                }}
            ></div>
            <div className="container">
                <div className="page-header__inner">
                    <div className="page-header__img-1">
                        <img loading="lazy" 
                            src="/assets/logo/store/loja_1.webp" 
                            alt="Roady Oliveira de Azeméis" 
                            style={{ width: '250px', height: '300px', objectFit: 'contain' }}
                        />
                    </div>
                    <h3>{store.title}</h3>
                    <div className="thm-breadcrumb__inner">
                        <ul className="thm-breadcrumb list-unstyled" id="store-breadcrumb">
                            <li><a href="/">{navigation.start}</a></li>
                            <li><span className="fas fa-angle-right"></span></li>
                            <li><a href="/loja">{store.title}</a></li>
                            <li id="breadcrumb-category-item" style={{ display: 'none' }}>
                                <span className="fas fa-angle-right"></span>
                            </li>
                            <li id="breadcrumb-category-name" style={{ display: 'none' }}></li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PageHeader;

